import * as React from 'react'

function IconUpload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={74}
      height={74}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={74} height={74} rx={37} fill="#F4BA27" fillOpacity={0.15} />
      <path
        d="M17.453 43.707V31.244c0-6.46 5.225-11.697 11.673-11.697h16.445c6.448 0 11.673 5.24 11.673 11.697v12.463M36.998 55.15V37"
        stroke="#F4BA27"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M44.678 40.49l-4.852-5.81a3.208 3.208 0 00-4.957 0l-4.852 5.81"
        stroke="#F4BA27"
        strokeWidth={5}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconUpload
